module.exports = __webpack_public_path__ + "img/mag_logo.95f716c0.png";